import { useEffect } from "react";

/**
 * Ensures `<meta name="robots" content="noindex,nofollow">` is applied while
 * the component is mounted, overriding any global "index,follow" tag that
 * index.html or another SEO component may have set. On unmount we restore the
 * previous value so other pages keep their normal indexing directives.
 *
 * Use on pages that must NEVER show up in Google: login/register/account/
 * password-reset/404/etc.
 */
export function useNoindex() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    const previous = meta ? meta.getAttribute("content") : null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex,nofollow");
    return () => {
      if (previous !== null) {
        // Restore whatever the previous SEO layer set (usually "index,follow…")
        meta.setAttribute("content", previous);
      } else if (meta.parentNode) {
        // We created it — remove it so we don't leak the tag
        meta.parentNode.removeChild(meta);
      }
    };
  }, []);
}
